export class Report {
    static fromExistingData(rep: any): Report {
        const report = new Report();
        if (rep.id) report.id = rep.id;
        if (rep.name) report.name = rep.name;
        if (rep.createdAt) report.createdAt = rep.createdAt;
        if (rep.createdBy) report.createdBy = rep.createdBy;
        if (rep.createdByName) report.createdByName = rep.createdByName;
        if (rep.status) report.status = rep.status;
        if (rep.links) report.links = rep.links;
        if (rep.reportTemplate) report.reportTemplate = rep.reportTemplate;
        report.isCanEdit = rep.isCanEdit;
        report.isCanDelete = rep.isCanDelete;

        return report;
    }

    constructor(
        public id: number = null,
        public name: string = '',
        public createdBy: string = '',
        public createdByName: string = '',
        public createdAt: string = '',
        public status: any = null,
        public reportTemplate: any = null,
        public links: any = null,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Report.ts